import AppLoading from "../../app-loading/app-loading";
import React, { useState, useEffect } from "react";
import CountrySearch from './CountrySearch';
import CountryDatatable from './Country-datatable';
import UserAddressService from '../../../services/useraddress/useraddress.service';
import { countryModel } from '../../../models/cust-address/cust-address-model';

const Countrydis: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [countryList, setcountryList] = useState<countryModel[]>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);  
  const [pageNumber, setPageNumber] = useState<number>(1);  
  const [pageSize, setPageSize] = useState<number>(10);   
  const [searchTerm, setSearchTerm] = useState<any>();

  useEffect(() => {
    fetchAllCountries(pageNumber, pageSize);
  }, []); 

  const reloadPage = (val: boolean) => {
    if (val) {
      fetchAllCountries(pageNumber, pageSize);
    }
  };

  const fetchAllCountries = async (pageNumber: number, pageSize: number) => {
    try {
      setLoading(true);
      const response = await UserAddressService.GetAllCountries(pageNumber, pageSize);
      setcountryList(response.countries);  
      setTotalRecords(response.totalRecords);  
    } catch (error) {
      console.error("Error fetching data:", error);
      setcountryList([]);  
    } finally {
      setLoading(false);
    }
  };

  const fetchFilteredCountries = async (searchTerm: string, pageNumber: number,pageSize: number) => {
    try {
      setLoading(true);
      const response = await UserAddressService.searchFilterCountries(searchTerm, pageNumber, pageSize);
      setcountryList(response.countries);  
      setTotalRecords(response.totalRecords);
    } catch (error) {
      console.error("Error filtering countries:", error);
      setcountryList([]);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = async (event: any) => {
    const newPageNumber = Math.floor(event.first / event.rows) + 1;
    const newPageSize = event.rows;
    setPageNumber(newPageNumber);
    setPageSize(newPageSize);

    if (searchTerm) {
      fetchFilteredCountries(searchTerm, newPageNumber, newPageSize);
    } else {
      fetchAllCountries(newPageNumber, newPageSize);
    }
  };

  return (
    <>
      <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
        <div className="col-12">
          <h5 className="ml-1 mb-0">{"Country"}</h5>
        </div>

        <CountrySearch 
          reloadPage={reloadPage} 
          setLoading={setLoading} 
          setPageNumber={setPageNumber} 
          setPageSize={setPageSize}
          setcountryList={setcountryList} 
          setSearchTerm={setSearchTerm} 
          setTotalRecords={setTotalRecords}
          fetchData={fetchFilteredCountries}
        />

        <CountryDatatable 
          data={countryList} 
          NoofRecords={totalRecords} 
          pageNumber={pageNumber} 
          pageSize={pageSize} 
          searchTerm={searchTerm}
          onPageChange={handlePageChange} 
          fetchData={fetchAllCountries}
        />
      </div>      
      {loading && <AppLoading />}
    </>
  );
};

export default Countrydis;
